import React from "react"
import classNames from "utils/classNames"
import CustomButton from "../Atoms/CustomButton"
import CustomCard, { CustomCardProps } from "components/Atoms/CustomCard"
interface SummaryCardProps extends CustomCardProps {
  isOpen?: boolean
  title?: string
  onClick?:
    | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
    | undefined
}
const SummaryCard = ({
  children,
  isOpen,
  onClick,
  title,
}: SummaryCardProps) => {
  return (
    <CustomCard
      className={classNames("vt-summary-card", {
        "vt-summary-card-close": !isOpen,
      })}
    >
      <header>
        <div className="flex justify-between items-center">
          <h6>{title}</h6>
          <CustomButton
            icon="cross"
            minimal
            intent="danger"
            onClick={onClick}
          />
        </div>
        <hr className="mt-1" />
      </header>
      {children}
    </CustomCard>
  )
}

export default SummaryCard
